var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavPhotoOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 130",
    d: "M457.875 3.15h-20.532a2.73 2.73 0 0 0-2.734 2.725v20.55a2.73 2.73 0 0 0 2.734 2.725h20.531a2.73 2.73 0 0 0 2.734-2.725V5.875a2.73 2.73 0 0 0-2.734-2.725",
    transform: "translate(-434.609 -3.15)",
    style: {
      fill: "#7833ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 131",
    d: "m462.375 48.579-3.551-2.945a1.172 1.172 0 0 0-1.626.128l-4.764 5.438a1.172 1.172 0 0 1-1.619.134l-4.121-3.362a1.171 1.171 0 0 0-1.677.207l-3.731 5.035a1.146 1.146 0 0 0 .937 1.824h19.4a1.154 1.154 0 0 0 1.161-1.147v-4.434a1.141 1.141 0 0 0-.414-.878",
    transform: "translate(-438.878 -30.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 132",
    d: "M460.6 29.848a3.124 3.124 0 1 0-3.124-3.125 3.124 3.124 0 0 0 3.124 3.125",
    transform: "translate(-449.632 -16.617)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPhotoOn);
export default __webpack_public_path__ + "static/media/nav_photo_on.50dbe97356e25a4e217785a092d270d9.svg";
export { ForwardRef as ReactComponent };